export const environment = {
	production: true,
	
	baseUrl: 'https://api.prowebtechnos.com/',
	apiUrl: 'https://api.prowebtechnos.com/api/',
	uploadUrl: 'https://api.prowebtechnos.com/uploads/',
	blogUrl:'https://api.prowebtechnos.com/api/proweb/',
};
